const { createAction } = require("../../helpers");
const {
  GET_PRODUCT,
  GET_PRODUCT_SUCCESS,
  GET_PRODUCT_RESET,
  GET_PRODUCT_ERROR,

  GET_PRODUCTS_LIST,
  GET_PRODUCTS_LIST_SUCCESS,
  GET_PRODUCTS_LIST_RESET,
  GET_PRODUCTS_LIST_ERROR,
} = require("./constants");

const product = (uuid) => createAction(GET_PRODUCT, { uuid });
const productSuccess = (data) => createAction(GET_PRODUCT_SUCCESS, { data });
const productError = (error) => createAction(GET_PRODUCT_ERROR, { error });
const productReset = () => createAction(GET_PRODUCT_RESET);

const productsList = ({ page, pageSize }) =>
  createAction(GET_PRODUCTS_LIST, { page, pageSize });
const productsListSuccess = (data) =>
  createAction(GET_PRODUCTS_LIST_SUCCESS, { data });
const productsListError = (error) =>
  createAction(GET_PRODUCTS_LIST_ERROR, { error });
const productsListReset = () => createAction(GET_PRODUCTS_LIST_RESET);

module.exports = {
  product,
  productSuccess,
  productError,
  productReset,

  productsList,
  productsListSuccess,
  productsListError,
  productsListReset,
};
